<ng-template #tooltip let-tooltipText>
  <div class="tooltip-container tooltip">
    <span class="tooltip-content">{{ tooltipText }}</span>
  </div>
</ng-template>
